(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('norma', {
            parent: 'entity',
            url: '/norma?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.norma.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/normas.html',
                    controller: 'NormaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('norma.nuevo', {
            parent: 'norma',
            url: '/nuevo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaPublicacion: null,
                                fechaDOF: null,
                                fechaSJFYG: null,
                                fechaSJFGaceta: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: true,
                                abrogado: false,
                                id: null,
                                palabrasClaves:[],
                                depuradoPors: [],
                                abrogadoPors:[]
                            };
                        },
                        organosResponse: function(){
                            return null;
                        },
                        documentosResponse:  function(){
                            return null;
                        }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('norma');
                });
            }]
        })

        .state('norma-detail', {
            parent: 'norma',
            url: '/norma/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.norma.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/norma-detail.html',
                    controller: 'NormaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Norma', function($stateParams, Norma) {
                    return Norma.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'norma',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('norma-detail.edit', {
            parent: 'norma-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('norma.new', {
            parent: 'norma',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog.html',
                    controller: 'NormaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaPublicacion: null,
                                fechaDOF: null,
                                fechaSJFYG: null,
                                fechaSJFGaceta: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: null,
                                abrogado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('norma');
                });
            }]
        })
        .state('norma.edit', {
            parent: 'norma',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('norma.delete', {
            parent: 'norma',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-delete-dialog.html',
                    controller: 'NormaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
